module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_41-0564a930a63cb81e29fdb305d4d2a871.png";